<script setup lang="ts">
import { provide, toRefs } from 'vue'
import BasicInfo from './BasicInfo.vue'
import Details from './Details.vue'
import Metadata from './Metadata.vue'
import Tags from './Tags.vue'

import type { File } from '@openapi'

const props = withDefaults(
  defineProps<{
    file: File
    isAdmin?: boolean
    isFileBrowser?: boolean
  }>(),
  { isAdmin: false, isFileBrowser: false },
)

provide('CFilePanelProps', toRefs(props))
</script>

<template>
  <div class="c-file-panel">
    <BasicInfo />
    <Details />
    <Metadata />
    <Tags />
  </div>
</template>
